"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const analytics_js_1 = __importDefault(require("@hh.ru/analytics-js"));
/** Событие отправляется, когда пользователь изменил какое-то из своих полей в резюме. Изменение визимости не учитывается. <br> В случае, если пользователь изменил несколько полей, событие отправляется один раз. */
const resumeEditExternal = () => analytics_js_1.default.sendEvent("applicant", "resume-edit", "success");
exports.default = resumeEditExternal;
